/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/components/progress/progress.tsx'.
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import classNames from 'classnames';
import omit from 'rc-util/lib/omit';
import { ConfigConsumer } from '../config-provider';
import { validProgress, getSuccessPercent } from 'antd/lib/progress/utils';
import { Icon } from '../icon';
import Line from 'antd/lib/progress/Line';
import Steps from 'antd/lib/progress/Steps';
import Circle from 'antd/lib/progress/Circle';
const ProgressStatuses = ['normal', 'active', 'success', 'error', 'warning', 'exception'];
class Progress extends React.Component {
    renderProcessInfo(prefixCls, progressStatus) {
        const { showInfo = true, format, type = 'line', percent, title } = this.props;
        const successPercent = getSuccessPercent(this.props);
        if (!showInfo) {
            return null;
        }
        let text;
        const textFormatter = format || ((percentNumber) => `${percentNumber}%`);
        const isLineType = type === 'line';
        let typeClass;
        if (format || (progressStatus !== 'success' && progressStatus !== 'error')) {
            text = textFormatter(validProgress(percent), validProgress(successPercent));
            typeClass = 'number';
        }
        else if (progressStatus === 'error') {
            text = isLineType ? React.createElement(Icon, { type: 'misuse--filled' }) : React.createElement(Icon, { type: 'close' });
            typeClass = 'icon';
        }
        else if (progressStatus === 'success') {
            text = isLineType ? React.createElement(Icon, { type: 'checkmark--filled' }) : React.createElement(Icon, { type: 'checkmark' });
            typeClass = 'icon';
        }
        if (title !== undefined && type === 'circle') {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: `${prefixCls}-text ${prefixCls}-${typeClass}`, title: typeof text === 'string' ? text : undefined },
                    React.createElement("span", { className: `${prefixCls}-text-number` }, text),
                    React.createElement("span", { className: `${prefixCls}-text-title` }, title))));
        }
        return (React.createElement("span", { className: `${prefixCls}-text ${prefixCls}-${typeClass}`, title: typeof text === 'string' ? text : undefined }, text));
    }
    renderProgress = ({ getPrefixCls, direction }) => {
        const { prefixCls: customizePrefixCls, size = 'middle', className: customizeClassName, strokeWidth, status = 'normal', type = 'line', steps, strokeColor, showInfo = true, 
        // strokeSize = 'medium',
        width, ...otherProps } = this.props;
        const prefixCls = getPrefixCls('progress', customizePrefixCls);
        const customProps = otherProps;
        let newStrokeWidth = strokeWidth;
        let newWidth = width;
        let newStrokeColor = strokeColor;
        let progressStatus = status === 'exception' ? 'error' : status;
        //根据size去修改strokeWidth
        if (!strokeWidth && type === 'line') {
            switch (size) {
                case 'small':
                    newStrokeWidth = 4;
                    break;
                case 'middle':
                    newStrokeWidth = 8;
                    break;
                case 'large':
                    newStrokeWidth = 12;
                    break;
            }
        }
        //在circle下根据size去修改Width，根据strokeSoze去修改strokewidth
        if ((type === 'circle' || type === 'dashboard') && newWidth === undefined) {
            newStrokeWidth = 8;
            switch (size) {
                case 'small':
                    newWidth = 104;
                    newStrokeWidth = Math.floor((8 * 100) / newWidth);
                    break;
                case 'middle':
                    newWidth = 144;
                    newStrokeWidth = Math.floor((8 * 100) / newWidth);
                    break;
                case 'large':
                    newWidth = 200;
                    newStrokeWidth = Math.floor((8 * 100) / newWidth);
                    break;
                case 'mini':
                    newWidth = 16;
                    newStrokeWidth = Math.floor((4 * 100) / newWidth);
                    customProps.strokeLinecap = 'square';
                    break;
            }
            // switch (strokeSize) {
            // 	case 'thin':
            // 		newStrokeWidth = Math.floor((4 * 100) / newWidth);
            // 		break;
            // 	case 'medium':
            // 		newStrokeWidth = Math.floor((8 * 100) / newWidth);
            // 		break;
            // 	case 'bold':
            // 		newStrokeWidth = Math.floor((12 * 100) / newWidth);
            // 		break;
            // }
        }
        //预设middle颜色
        if (progressStatus === 'warning') {
            newStrokeColor = {
                '0%': '#FF7E33',
                '100%': '#FFAB00'
            };
        }
        //预设normal下渐变色
        if (!newStrokeColor && progressStatus === 'normal') {
            newStrokeColor = {
                '0%': '#1B58F4',
                '100%': '#457AFF '
            };
        }
        if (!newStrokeColor && progressStatus === 'success') {
            newStrokeColor = {
                '0%': '#029469',
                '100%': '#29A64E'
            };
        }
        if (!newStrokeColor && progressStatus === 'error') {
            newStrokeColor = {
                '0%': '#C82727',
                '100%': '#EC4344'
            };
        }
        customProps.strokeWidth = newStrokeWidth;
        customProps.status = progressStatus;
        customProps.strokeColor = newStrokeColor;
        customProps.width = newWidth;
        const className = classNames({
            [`${prefixCls}-${(type === 'dashboard' && 'circle') || (steps && 'steps') || type}`]: true,
            [`${prefixCls}-status-${progressStatus}`]: true,
            [`${prefixCls}-show-info`]: showInfo,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-sm`]: size === 'small',
            [`${prefixCls}-m`]: size === 'middle',
            [`${prefixCls}-lg`]: size === 'large',
            [`${prefixCls}-mini`]: size === 'mini'
        }, customizeClassName);
        const progressInfo = this.renderProcessInfo(prefixCls, progressStatus);
        let progress;
        if (type === 'line') {
            progress = steps ? (
            // @ts-ignore
            React.createElement(Steps, { ...customProps, 
                // @ts-ignore
                size: size, strokeColor: typeof strokeColor === 'string' ? strokeColor : undefined, prefixCls: prefixCls, steps: steps }, progressInfo)) : (
            //@ts-ignore
            React.createElement(Line, { ...customProps, prefixCls: prefixCls, direction: direction }, progressInfo));
        }
        else if (type === 'circle' || type === 'dashboard') {
            progress = (
            // @ts-ignore
            React.createElement(Circle, { ...customProps, prefixCls: prefixCls, progressStatus: progressStatus }, progressInfo));
        }
        return (React.createElement("div", { ...omit(customProps, [
                'status',
                'format',
                'trailColor',
                // 'strokeWidth',
                'strokeColor',
                'width',
                'gapDegree',
                'gapPosition',
                'strokeLinecap',
                'percent',
                'success',
                'successPercent'
            ]), className: className }, progress));
    };
    render() {
        return React.createElement(ConfigConsumer, null, this.renderProgress);
    }
}
// export default withConfigProvider(Progress);
export default Progress;
